import React from "react";
import { Box, Button, Typography } from "@mui/material";

export default function RealEstatePageHeader({ title, description, actionLabel, onAction, actionDisabled = false }) {
  return (
    <Box sx={{ display: "flex", gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", flexDirection: { xs: "column", sm: "row" } }}>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h4" sx={{ fontWeight: 950, color: "var(--wp-panel-text-primary, #19242F)", fontSize: { xs: 28, sm: 34 } }}>
          {title}
        </Typography>
        {description ? <Typography sx={{ mt: .5, color: "rgba(var(--wp-panel-ink-rgb, 25,36,47),.65)" }}>{description}</Typography> : null}
      </Box>
      {actionLabel && onAction ? (
        <Button variant="contained" onClick={onAction} disabled={actionDisabled} sx={{ fontWeight: 900, textTransform: "none", borderRadius: 2, flexShrink: 0 }}>
          {actionLabel}
        </Button>
      ) : null}
    </Box>
  );
}
